/**
 * Rosa MX H5 素材路径（镜像自源站 tau777.mx，落在 public/skins/rosa-mx-h5，不走源站 CDN）。
 * 品牌类素材（logo / 立绘 / 牌照 / 客服链接）为占位，上线前必须替换为新站自己的。
 */
const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;

export const ROSA_MX_SKIN_CODE = 'rosa-mx-h5';
export const rosaMxSkinRoot = `${publicBase}skins/${ROSA_MX_SKIN_CODE}`;

const a = (path: string) => `${rosaMxSkinRoot}/${path}`;

export const rosaMxAssets = {
  activity: {
    banners: Array.from({ length: 11 }, (_, i) => a(`activity/banners/${i + 1}.webp`)),
    icons: {
      ganar200: a('activity/icons/ganar200.webp'),
      promocional: a('activity/icons/promocional.webp'),
      ranking: a('activity/icons/ranking.webp'),
      vip: a('activity/icons/vip.webp'),
      wallCheckin: a('activity/icons/wall-checkin.webp'),
      wallDailyRescue: a('activity/icons/wall-daily-rescue.webp'),
      wallFirstDeposit: a('activity/icons/wall-first-deposit.webp'),
      wallInvite: a('activity/icons/wall-invite.webp'),
      wallRecharge: a('activity/icons/wall-recharge.webp'),
      wallWeeklyRescue: a('activity/icons/wall-weekly-rescue.webp'),
      wallWelcome: a('activity/icons/wall-welcome.webp'),
      wallWheel: a('activity/icons/wall-wheel.webp'),
    },
    wheel: {
      bgLight: a('activity/wheel/bg-light.png'),
      disk: a('activity/wheel/disk.webp'),
      gold: a('activity/wheel/gold.webp'),
      iphone: a('activity/wheel/iphone.png'),
      light1: a('activity/wheel/light1.png'),
      light2: a('activity/wheel/light2.png'),
      macbook: a('activity/wheel/macbook.png'),
      money: a('activity/wheel/money.png'),
      pointer: a('activity/wheel/pointer.webp'),
    },
  },
  popup: {
    inviteExit: a('popups/invite-exit.png'),
    checkin: a('popups/checkin.webp'),
    firstRecharge: a('popups/first-recharge.webp'),
  },
  redeem: {
    close: a('redeem/close.svg'),
    gift: a('redeem/gift-box.webp'),
  },
  auth: {
    flagMx: a('auth/flag-mx.png'),
    giftBox: a('auth/gift-box.png'),
    hero: a('auth/hero.webp'),
  },
  banners: Array.from({ length: 11 }, (_, i) => a(`banners/${i + 1}.webp`)),
  deposit: {
    /** 金额格角标底板（源站 Obter / BknIa9Jy.svg） */
    chipBadge: a('deposit/chip-badge.svg'),
    /** 金额输入右侧宝箱：外框 + 箱体 */
    chest: a('deposit/chest.webp'),
    chestFrame: a('deposit/chest-frame.webp'),
    /** 抽屉头右上钱包/记录（源站 DHMMa7IH.svg，18×16） */
    records: a('deposit/records.svg'),
    /** 充值页跑马灯两侧小喇叭（源站 DpqKwMlv.webp） */
    tickerSpeaker: a('deposit/ticker-speaker.webp'),
  },
  withdraw: {
    /** 源站 Retiro 标题栏右客服头像（C29CXa4K.svg，可带红点） */
    cs: a('withdraw/cs.svg'),
  },
  download: {
    /** 源站 #/download 的「添加到主屏幕」iOS 引导图（1080×1565） */
    iosGuide: a('download/ios-guide.png'),
  },
  drawer: {
    back: a('drawer/back.svg'),
    headerBg: a('drawer/header-bg.webp'),
    service: a('drawer/service.svg'),
  },
  menu: {
    addHome: a('menu/add-home.svg'),
    bono: a('menu/bono.svg'),
    recargar: a('menu/recargar.svg'),
    retiro: a('menu/retiro.svg'),
    support: a('menu/support.svg'),
  },
  profile: {
    /** 源站登录态默认头像（130×130 png） */
    avatarDefault: a('profile/avatar-default.png'),
    avatarGuest: a('profile/avatar-guest.webp'),
    bannerInvite: a('profile/banner-invite.webp'),
    bannerWheel: a('profile/banner-wheel.webp'),
    coin: a('profile/coin.png'),
    langEn: a('profile/lang-en.svg'),
    langEs: a('profile/lang-es.svg'),
    message: a('profile/message.svg'),
    service: a('profile/service.svg'),
    vipBadge: a('profile/vip-badge.svg'),
  },
  bg: {
    home: a('bg/home-bg.webp'),
    homeDeco: a('bg/home-deco.webp'),
  },
  float: {
    car: a('float/f2.webp'),
    carFrame: a('float/f1.webp'),
    carLabel: a('float/f3.webp'),
    close: a('float/close.svg'),
    redpacketBg: a('float/f4.webp'),
    redpacketLabel: a('float/f5.png'),
    telegram: a('float/f6.webp'),
    whatsapp: a('float/f7.png'),
  },
  fonts: {
    iconfont: a('fonts/iconfont.woff2'),
    montserrat: a('fonts/Montserrat-Regular.otf'),
  },
  footer: {
    /** 源站页脚尾部 el-backtop 内的「Top」按钮图（121×35 svg，DdLGXiAE.svg） */
    backtop: a('footer/backtop.svg'),
    licenses: [a('footer/license-1.webp'), a('footer/license-2.webp')],
    providers: Array.from({ length: 9 }, (_, i) => a(`footer/provider-${i + 1}.svg`)),
    shares: Array.from({ length: 5 }, (_, i) => a(`footer/share-${i + 1}.svg`)),
  },
  game: {
    people: a('game/people.svg'),
    /** 源站 #/game .quitGame 50×50（实测 56.25，设计 50） */
    quit: a('game/quit.webp'),
  },
  brand: {
    /** 源站 shortcut icon（48×48 ico，品牌占位，上线前替换） */
    favicon: a('brand/favicon.ico'),
  },
  header: {
    /** 登录态右侧头像（39×39 svg，源站点击进 Mensaje） */
    avatar: a('header/avatar.svg'),
    giftBox: a('header/gift-box.webp'),
    logo: a('brand/logo.png'),
    menu: a('header/menu.svg'),
    /** 登录态余额胶囊尾部「+」（30×30 svg，进 Depositar） */
    plus: a('header/plus.svg'),
    sun: a('header/sun.png'),
  },
  invite: {
    arrow: a('invite/arrow.webp'),
    back: a('invite/back.svg'),
    center: a('invite/center.webp'),
    claimed: a('invite/claimed.webp'),
    chest: a('invite/chest.webp'),
    deposit: a('invite/deposit.svg'),
    dingbu: a('invite/dingbu.webp'),
    finger: a('invite/finger.png'),
    jackpot: a('invite/jackpot.jpg'),
    left: a('invite/left.webp'),
    poster: (id: string) => a(`invite/posters/${id}.webp`),
    right: a('invite/right.webp'),
    slot: a('invite/slot.svg'),
    social: {
      email: a('invite/social/email.svg'),
      facebook: a('invite/social/facebook.svg'),
      instagram: a('invite/social/instagram.svg'),
      telegram: a('invite/social/telegram.svg'),
      whatsapp: a('invite/social/whatsapp.svg'),
      x: a('invite/social/x.svg'),
    },
  },
  vip: {
    bonus: {
      bet: a('vip/bonus-bet.png'),
      cashback: a('vip/bonus-cashback.webp'),
      daily: a('vip/bonus-daily.webp'),
      deposit: a('vip/bonus-deposit.png'),
      monthly: a('vip/bonus-monthly.webp'),
      rescue: a('vip/bonus-rescue.webp'),
      upgrade: a('vip/bonus-upgrade.webp'),
      weekly: a('vip/bonus-weekly.webp'),
    },
    hero: a('vip/hero.webp'),
    heroBase: a('vip/hero-base.webp'),
    levels: Array.from({ length: 26 }, (_, i) => a(`vip/levels/${i}.webp`)),
    period: {
      day: a('vip/period-day.webp'),
      month: a('vip/period-month.webp'),
      week: a('vip/period-week.webp'),
    },
    wheel: a('vip/wheel.webp'),
  },
  nav: {
    bg: a('nav/tabbar-bg.webp'),
    bonos: a('nav/bonos.webp'),
    depositar: a('nav/depositar.webp'),
    personal: a('nav/personal.webp'),
    promociones: a('nav/promociones.webp'),
    retirar: a('nav/retirar.webp'),
  },
  sign: {
    boxes: [
      a('sign/box1.webp'),
      a('sign/box2.webp'),
      a('sign/box3.webp'),
      a('sign/box4.webp'),
      a('sign/box5.webp'),
    ],
    cash: a('sign/cash.webp'),
    vipTab: (id: string) => a(`sign/vip/${id}.png`),
  },
  quick: {
    canjear: a('quick/canjear.webp'),
    checkin: a('quick/checkin.webp'),
    frame: a('quick/frame.webp'),
    labelBg: a('quick/label-bg.webp'),
    misterioso: a('quick/misterioso.webp'),
    ruleta: a('quick/ruleta.webp'),
    semana: a('quick/semana.webp'),
  },
  tabs: {
    active: a('tabs/tab-active.webp'),
    idle: a('tabs/tab.webp'),
  },
  ticker: {
    cap: a('ticker/cap.webp'),
  },
} as const;

export const rosaMxThemeTokenUrl = a('theme-tokens.json');
